import React, { useEffect, useState } from 'react';
import Access from "../components/Access";
import Navbar from "../components/Navbar";
import NavbarAdmin from "../components/NavbarAdmin";
import ModalUpdateUser from "../components/ModalUpdateUser";
import { rescueHtml } from '../components/Tools';
import Checked from '../Img/icon-checked.png';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';


const Restitutions = (props) =>
{
    const [aff, setAff] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [userFocus, setUserFocus] = useState(false);
    const [liste, setListe] = useState([]);
    const [boolID, setBoolID] = useState(true);
    const [boolMatricule, setBoolMatricule] = useState(false);
    const [boolNumero, setBoolNumero] = useState(false);
    const [boolNiveau, setBoolNiveau] = useState(false);
    const [boolDescription, setBoolDescription] = useState(false);
    const [boolFormule, setBoolFormule] = useState(false);
    const [boolFlag, setBoolFlag] = useState(false);
    const [boolType, setBoolType] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const heightObject = window.innerHeight/1.9;

    const purple = '#6571FE';
    const green = '#59B44A';
    const blue = '#069BD3';

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        }
        else {

        }
    }, [props.user])


    async function getRestitution(e)
    {
        console.log(e.target.value);
        axios.post("https://app-slfinance.fr/api/restitution.php", qs.stringify({'getRestitutionData': true, 'restitution': e.target.value}))
        .then((res) => {
            console.log(res.data);
            setListe(res.data);
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    function compareIdAsc(a, b)
    {
        return a[0] - b[0];
    }

    function compareIdDes(a, b)
    {
        return b[0] - a[0];
    }

    function compareMatriculeAsc(a, b)
    {
        const matriculeA = a[1]?a[1].toUpperCase():0;
        const matriculeB = b[1]?b[1].toUpperCase():0;
        
        if (matriculeA < matriculeB) return -1;
        if (matriculeA > matriculeB) return 1;
        return 0;
    }

    function compareMatriculeDes(a, b)
    {
        const matriculeA = a[1]?a[1].toUpperCase():0;
        const matriculeB = b[1]?b[1].toUpperCase():0;
        
        if (matriculeA > matriculeB) return -1;
        if (matriculeA < matriculeB) return 1;
        return 0;
    }

    function compareNumeroAsc(a, b)
    {
        return a[2] - b[2];
    }

    function compareNumeroDes(a, b)
    {
        return b[2] - a[2];
    }

    function compareNiveauAsc(a, b)
    {
        return a[3] - b[3];
    }

    function compareNiveauDes(a, b)
    {
        return b[3] - a[3];
    }

    function compareDescriptionAsc(a, b)
    {
        const descA = a[4]?a[4].toUpperCase():0;
        const descB = b[4]?b[4].toUpperCase():0;
        
        if (descA < descB) return -1;
        if (descA > descB) return 1;
        return 0;
    }

    function compareDescriptionDes(a, b)
    {
        const descA = a[4]?a[4].toUpperCase():0;
        const descB = b[4]?b[4].toUpperCase():0;
        
        if (descA > descB) return -1;
        if (descA < descB) return 1;
        return 0;
    }

    function compareFormuleAsc(a, b)
    {
        const formA = a[5]?a[5].toUpperCase():0;
        const formB = b[5]?b[5].toUpperCase():0;
        
        if (formA < formB) return -1;
        if (formA > formB) return 1;
        return 0;
    }

    function compareFormuleDes(a, b)
    {
        const formA = a[5]?a[5].toUpperCase():0;
        const formB = b[5]?b[5].toUpperCase():0;
        
        if (formA > formB) return -1;
        if (formA < formB) return 1;
        return 0;
    }

    function compareFlagAsc(a, b)
    {
        return a[6] - b[6];
    }

    function compareFlagDes(a, b)
    {
        return b[6] - a[6];
    }

    function compareTypeAsc(a, b)
    {
        const typeA = a[7]?a[7].toUpperCase():0;
        const typeB = b[7]?b[7].toUpperCase():0;
        
        if (typeA < typeB) return -1;
        if (typeA > typeB) return 1;
        return 0;
    }

    function compareTypeDes(a, b)
    {
        const typeA = a[7]?a[7].toUpperCase():0;
        const typeB = b[7]?b[7].toUpperCase():0;
        
        if (typeA > typeB) return -1;
        if (typeA < typeB) return 1;
        return 0;
    }

	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />
            <ModalUpdateUser
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            user={userFocus}
            who={props.user?props.user.id:null}
            />

            <div style={{display: 'flex', margin: 25}}>
                <p>Gestion \</p>
                <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Restitutions</p>
                <div style={{display: 'flex', marginLeft: 100}}>
                    <select className='shadow-md' style={{width: 350, padding: 5, marginLeft: 10}} onChange={(e) => {getRestitution(e)}}>
                        <option value=''>Les restitutions</option>
                        {
                            [
                                {'id': 1, 'nom': 'Communes Fonctionnement Retro', 'value': 'ComRetroFct%'},
                                {'id': 2, 'nom': 'Communes Fonctionnement Prosp', 'value': 'ComProspFct%'},
                                {'id': 3, 'nom': 'Communes Investissement Retro', 'value': 'ComRetroInv%'},
                                {'id': 4, 'nom': 'Communes Investissement Prosp', 'value': 'ComProspInv%'},
                                {'id': 5, 'nom': 'Epci Fonctionnement Retro', 'value': 'EpciRetroFct%'},
                                {'id': 6, 'nom': 'Epci Fonctionnement Prosp', 'value': 'EpciProspFct%'},
                                {'id': 7, 'nom': 'Epci Investissement Retro', 'value': 'EpciRetroInv%'},
                                {'id': 8, 'nom': 'Epci Investissement Prosp', 'value': 'EpciProspInv%'}
                            ]
                            .map((organisme) => 
                            <option key={organisme['id']} value={organisme['value']}>{organisme['nom']}</option>
                            )
                        }
                    </select>
                </div>
            </div>


            <div className='shadow-md rounded-md' style={{margin: isMobile ? 10 : 50}}>
                <div style={{overflowY: 'scroll'}}>
                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white', flexWrap: isMobile ? 'wrap' : 'nowrap'}}>
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolMatricule) {
                                await liste.sort(compareMatriculeDes);
                            }
                            else {
                                await liste.sort(compareMatriculeAsc);
                            }
                            await setBoolMatricule(!boolMatricule);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.25, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: '8px', fontSize: '14px', minHeight: '40px', minWidth: '90px'}}>
                            <p>Matricule</p>
                        </button>
                        )}
                        
                        <button
                        onClick={async () => {
                            if (boolNumero) {
                                await liste.sort(compareNumeroDes);
                            }
                            else {
                                await liste.sort(compareNumeroAsc);
                            }
                            await setBoolNumero(!boolNumero);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 15%' : 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', minHeight: isMobile ? '32px' : '40px', minWidth: '45px'}}>
                            <p>Rang</p>
                        </button>
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolNiveau) {
                                await liste.sort(compareNiveauDes);
                            }
                            else {
                                await liste.sort(compareNiveauAsc);
                            }
                            await setBoolNiveau(!boolNiveau);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: '8px', fontSize: '14px', minHeight: '40px', minWidth: '85px'}}>
                            <p>Indentation</p>
                        </button>
                        )}
                        
                        <button
                        onClick={async () => {
                            if (boolDescription) {
                                await liste.sort(compareDescriptionDes);
                            }
                            else {
                                await liste.sort(compareDescriptionAsc);
                            }
                            await setBoolDescription(!boolDescription);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? 1 : 1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', minHeight: isMobile ? '32px' : '40px', minWidth: '100px'}}>
                            <p>{isMobile ? 'Int' : 'Intitulé'}</p>
                        </button>
                        
                        {!isMobile && (
                        <button
                        onClick={async () => {
                            if (boolFormule) {
                                await liste.sort(compareFormuleDes);
                            }
                            else {
                                await liste.sort(compareFormuleAsc);
                            }
                            await setBoolFormule(!boolFormule);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.6, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: '8px', fontSize: '14px', minHeight: '40px', minWidth: '150px'}}>
                            <p>Calcul</p>
                        </button>
                        )}
                        
                        <button
                        onClick={async () => {
                            if (boolFlag) {
                                await liste.sort(compareFlagDes);
                            }
                            else {
                                await liste.sort(compareFlagAsc);
                            }
                            await setBoolFlag(!boolFlag);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 10%' : 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', minHeight: isMobile ? '32px' : '40px', minWidth: '60px'}}>
                            <p>Chapitre</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolType) {
                                await liste.sort(compareTypeDes);
                            }
                            else {
                                await liste.sort(compareTypeAsc);
                            }
                            await setBoolType(!boolType);
                            await setAff(!aff);
                        }}
                        style={{flex: isMobile ? '0 0 15%' : 0.15, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', borderRight: '1px solid white', minHeight: isMobile ? '32px' : '40px', minWidth: '60px'}}>
                            <p>RecDep</p>
                        </button>
                    
                    </div>
                </div>

                <div style={{overflowY: 'scroll', maxHeight: heightObject}}>
                    {liste.map((ligne, i) =>
                    <div key={i} style={{display: 'flex', flexWrap: isMobile ? 'wrap' : 'nowrap', width: '100%'}}>
                        {!isMobile && (
                        <button style={{flex: 0.25, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, overflowX: 'hidden', padding: '8px', alignItems: 'center', minHeight: '40px', minWidth: '90px'}}>
                            <p style={{marginLeft: 5, fontSize: '12px'}}>{ligne[1]}</p>
                        </button>
                        )}
                        <button style={{flex: isMobile ? '0 0 15%' : 0.1, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', justifyContent: 'center', alignItems: 'center', minHeight: isMobile ? '32px' : '40px', minWidth: '45px'}}>
                            <p>{ligne[2]}</p>
                        </button>
                        {!isMobile && (
                        <button style={{flex: 0.1, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden', padding: '8px', justifyContent: 'center', alignItems: 'center', minHeight: '40px', minWidth: '85px'}}>
                            <p>{ligne[3]}</p>
                        </button>
                        )}
                        <button style={{flex: isMobile ? 1 : 1, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, overflowX: 'hidden', padding: isMobile ? '6px 2px' : '8px', alignItems: 'center', minHeight: isMobile ? '32px' : '40px', minWidth: '100px'}}>
                            <p style={{marginLeft: 5, fontSize: isMobile ? '10px' : '14px'}}>{ligne[4]}</p>
                        </button>
                        {!isMobile && (
                        <button style={{flex: 0.6, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, overflowX: 'hidden', padding: '8px', alignItems: 'center', minHeight: '40px', minWidth: '150px'}}>
                            <p style={{marginLeft: 5, fontSize: '11px'}}>{ligne[5]}</p>
                        </button>
                        )}
                        <button style={{flex: isMobile ? '0 0 10%' : 0.1, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', justifyContent: 'center', alignItems: 'center', minHeight: isMobile ? '32px' : '40px', minWidth: '60px'}}>
                            <p>{ligne[6]}</p>
                        </button>
                        <button style={{flex: isMobile ? '0 0 15%' : 0.15, display: 'flex', borderBottom: '1px solid '+blue, borderLeft: '1px solid '+blue, borderRight: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden', padding: isMobile ? '6px 2px' : '8px', fontSize: isMobile ? '11px' : '14px', justifyContent: 'center', alignItems: 'center', minHeight: isMobile ? '32px' : '40px', minWidth: '60px'}}>
                            <p>{ligne[7]}</p>
                        </button>
                    </div>
                    )}

                </div>

            </div>

        </Access>
	);
}


export default Restitutions;
